import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PdfService } from '@core/services/pdf.service';
import { combineLatest, EMPTY, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

interface UpdateEntry {
  id: string;
  title: string;
  description: string;
  date: string;
  imgPath: string;
}

@Component({
  selector: 'app-cnseg-updates',
  templateUrl: './cnseg-updates.component.html',
  styleUrls: ['./cnseg-updates.component.scss']
})
export class CnsegUpdatesComponent implements OnInit, OnDestroy {

  updateTemplates: UpdateEntry[] = [];
  currentUpdate: UpdateEntry | null = null;
  currentHtml: SafeHtml | null = null;

  private destroy$ = new Subject<void>();

  constructor(
    private _pdfService: PdfService,
    private _activatedRoute: ActivatedRoute,
    private _http: HttpClient,
    private _sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    combineLatest([
      this._http.get<UpdateEntry[]>('assets/data/updates.json'),
      this._activatedRoute.params
    ]).pipe(
      takeUntil(this.destroy$),
      switchMap(([updates, params]) => {
        this.updateTemplates = updates;

        if (!params['id']) {
          this.currentUpdate = null;
          this.currentHtml = null;
          return EMPTY;
        }

        const update = updates.find(u => u.id === params['id']) ?? null;
        this.currentUpdate = update;

        if (!update) {
          this.currentHtml = null;
          return EMPTY;
        }

        return this._http.get(`assets/data/updates/${update.id}.html`, { responseType: 'text' });
      })
    ).subscribe(html => {
      this.currentHtml = this._sanitizer.bypassSecurityTrustHtml(html as string);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  exportPDF(): void {
    this._pdfService.beforeCanvas('updateContainer');
    window.onafterprint = () => {
      this._pdfService.afterCanvas('updateContainer');
    };
    window.print();
  }

}
